export const customFieldsUtm = "?utm_source=HelpDesk+App&utm_medium=CTA&utm_campaign=custom-fields";
export const emailTemplatesUtm = "?utm_source=HelpDesk+App&utm_medium=CTA&utm_campaign=email-templates";
